import UsersManagerDetail from './UsersManagerDetail'
export default UsersManagerDetail
